import { KojinResult } from "interface/kojin"
import { useCallback, useMemo, useState } from "react"

type useExtendThresholdProps = {
	kojinList: KojinResult[] | null
}
export const useExtendThreshold = ({
	kojinList
}: useExtendThresholdProps) => {
  const [extendThresholdRate, setExtendThresholdRate] = useState<number>(50)
  const [extendLimittedCount, setExtendLimittedCount] = useState<number | null>(null)

  const counts = useMemo(
		() => kojinList?.reduce(
			(sum, kojin) => kojin.target?.sourceType === 1 ? { ...sum, extend: sum.extend + 1 } : { ...sum, source: sum.source + 1 },
			{ source: 0, extend: 0 }
		),
		[kojinList]
	)
  const { limittedList, extended } = useMemo(
    () => {
      const extended = (kojinList && counts && counts.extend > 0) ? (
        (extendLimittedCount !== null) ? Math.min(Math.max(0, extendLimittedCount), counts.extend) :
        (extendThresholdRate !== 0) ? Math.ceil((extendThresholdRate * counts.extend) / 100) : 0
      ) : 0
      const limittedList = (kojinList && counts) ? (
        kojinList.slice(counts.extend - extended)
      ) : null
      return { limittedList, extended }
    },
    [kojinList, counts, extendThresholdRate, extendLimittedCount]
  )
  const setExtendThreshold = useCallback(
    (rate: number, count?: number) => {
      setExtendThresholdRate(rate)
      setExtendLimittedCount(count ?? null)
    },
    [setExtendThresholdRate, setExtendLimittedCount]
  )
	return useMemo(() => ({
		setExtendThreshold, extendThresholdRate,
		counts, limittedList, extended
	}), [
		setExtendThreshold, extendThresholdRate,
		counts, limittedList, extended
	])
}
